import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PersonaDto } from '../dto/persona-dto';
import { catchError } from 'rxjs/operators';
import { UidDto } from '../dto/uid-dto';
import { UsuarioGrupo } from '../model/usuario-grupo';
import { DocentesDependenciaUaaDto } from '../dto/docentes-dependencia-uaa-dto';

@Injectable({
  providedIn: 'root'
})
export class PersonaService {

  private url: string = `${environment.host}/api/persona`;

  constructor(
    private http: HttpClient
  ) { }

  public datosPersonales(): Observable<PersonaDto> {
    return this.http.get<PersonaDto>(`${this.url}/info-vista`).pipe(catchError(error => {
      console.log('Error service Persona-datosPersonales', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  public ObtenerUid(): Observable<UidDto[]> {
    return this.http.get<UidDto[]>(`${this.url}/perfiles`).pipe(catchError(error => {
      console.log('Error service Persona-obtenerUid', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  public ObtenerPerfiles(): Observable<UsuarioGrupo[]> {
    return this.http.get<UsuarioGrupo[]>(`${this.url}/perfil`).pipe(catchError(error => {
      console.log('Error service Persona-obtenerUid', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  public getJefes(uaa:number): Observable<DocentesDependenciaUaaDto[]> {
    return this.http.get<DocentesDependenciaUaaDto[]>(`${this.url}/jefes/${uaa}`).pipe(catchError(error => {
      console.log('Error service Persona-getJefes', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  public validarEstudiante(): Observable<boolean> {
    return this.http.get<boolean>(`${this.url}/validar-est`).pipe(catchError(error => {
      console.log('Error service Persona-validarEstudiante', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  public validarOtros(): Observable<boolean> {
    return this.http.get<boolean>(`${this.url}/validar-otros`).pipe(catchError(error => {
      console.log('Error service Persona-validarOtros', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }


  public getPeriodo(codigo: number): Observable<string> {
    return this.http.get<string>(`${this.url}/obt-periodo/${codigo}`).pipe(catchError(error => {
      console.log('Error service Persona-getPeriodo', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  public validarFecha(): Observable<boolean> {
    return this.http.get<boolean>(`${this.url}/validarFecha`).pipe(catchError(error => {
      console.log('Error service Persona-validarFecha', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }
}
